<template>
  <v-data-table :headers="headers"
                hide-default-footer
                :items="templates"
                :items-per-page="-1"
                :loading="loading"
                dense
                multi-sort
                :sort-by="['slug']"
                :sort-desc="[true, true, false]"
                no-data-text="There are no templates here.">
    <template v-slot:item.edit="{item: template}">
      <v-btn v-if="template.user_id === user.id"
             :to="{name: `${$root.routePrefix}.share_template.edit`, params: {templateID: template.id}}"
             x-small>
        Edit
      </v-btn>
      <v-btn v-else-if="template.can_be_copied"
             :to="{name: `${$root.routePrefix}.share_template.create`, query: {source: template.id}}"
             x-small>
        Copy
      </v-btn>
    </template>
    <template v-slot:item.slug="{item: template}">
      {{ template.name }}
    </template>
    <template v-slot:item.is_campaign="{item: template}">
      {{ template.is_campaign ? 'Yes' : 'No' }}
    </template>
    <template v-slot:item.user="{item:template}">
      <template v-if="template.user">
        {{ template.user.name }}
      </template>
    </template>
  </v-data-table>
</template>
<style lang="scss">
.Column__Name {
  max-width: 300px;
}
</style>
<script>
import {mapGetters} from "vuex";
import ShareTemplateMenu from "../components/ShareTemplateMenu";

export default {
  components: {ShareTemplateMenu},
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    templates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: '',
          value: 'edit',
          sortable: false,
        },
        {
          text: 'Name',
          value: 'slug',
          width: '300px',
          cellClass: 'Column__Name text-truncate',
        },
        {
          text: 'Subject',
          value: 'subject',
          width: '300px',
          cellClass: 'Column__Subject text-truncate',
        },
        {
          text: 'Use in Campaigns',
          value: 'is_campaign',
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
  }
}
</script>
